import Category from "@/pcm/store/models/Category";
import Client from "@/pcm/store/models/Client";
import ClientContract from "@/pcm/store/models/ClientContract";
import ClientPaymentInformation from "@/pcm/store/models/ClientPaymentInformation";
import Company from "@/pcm/store/models/Company";
import Contract from "@/pcm/store/models/Contract";
import ContractImport from "@/pcm/store/models/ContractImport";
import ContractImportMedia from "@/pcm/store/models/ContractImportMedia";
import Country from "@/pcm/store/models/Country";
import Creator from "@/pcm/store/models/Creator";
import CreatorNote from "@/pcm/store/models/CreatorNote";
import CreatorPaymentInformation from "@/pcm/store/models/CreatorPaymentInformation";
import Currency from "@/pcm/store/models/Currency";
import Media from "@/pcm/store/models/Media";
import MediaView from "./models/MediaView";
import Network from "@/pcm/store/models/Network";
import NewClient from "@/pcm/store/models/NewClient";
import Page from "./models/Page";
import Permission from "@/pcm/store/models/Permission";
import Platform from "@/pcm/store/models/Platform";
import Role from "@/pcm/store/models/Role";
import SubscriptionClient from "@/pcm/store/models/SubscriptionClient";
import Tag from "@/pcm/store/models/Tag";
import User from "@/pcm/store/models/User";
import VuexORM from '@vuex-orm/core';
import SubscriptionClientSocial from "@/pcm/store/models/SubscriptionClientSocial";
import SubscriptionClientActivity from "@/pcm/store/models/SubscriptionClientActivity";
import SubscriptionClientYoutubeAccount from "@/pcm/store/models/SubscriptionClientYoutubeAccount";

const database = new VuexORM.Database();
database.register(Category);
database.register(Client);
database.register(ClientContract);
database.register(ClientPaymentInformation);
database.register(Company);
database.register(Contract);
database.register(ContractImport);
database.register(ContractImportMedia);
database.register(Country);
database.register(Creator);
database.register(CreatorNote);
database.register(CreatorPaymentInformation);
database.register(Currency);
database.register(Media);
database.register(MediaView);
database.register(Network);
database.register(NewClient);
database.register(Page);
database.register(Permission);
database.register(Platform);
database.register(Role);
database.register(SubscriptionClient);
database.register(SubscriptionClientActivity);
database.register(SubscriptionClientSocial);
database.register(SubscriptionClientYoutubeAccount);
database.register(Tag);
database.register(User);

export default database
